export default "__VITE_ASSET__2LFcR5XM__"